<script setup lang="ts">
const props = defineProps(["accData", "panel", "index", "open"]);

const accordion = ref(props?.accData ?? []);
interface Panel {
  tipHeading: string;
  tip: string;
  open: boolean;
}
const toggleOpen = (index: number) => {
  const newAccordion = accordion.value.map((panel: Panel, i: number) => {
    if (index === i) {
      return { ...panel, open: !panel.open };
    } else {
      return { ...panel, open: false };
    }
  });

  // Update the accordion data
  accordion.value = newAccordion;
};
</script>

<template>
  <div class="accordion">
    <AppAccPanel
      v-for="(panel, i) in accordion"
      :key="i"
      :panel="panel"
      :index="i"
      :open="panel.open"
      @toggle-open="toggleOpen"
    />
  </div>
</template>
